import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import './css/tokens.css'
import './css/theme.css'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import Vuelidate from 'vuelidate'
import { apiServer } from '../src/setup-axios'
import VueInteractJs from "vue-interactjs";
import { initKeycloak } from "./services/KeycloakService";
import { trackNavigation } from "./utils/navHistory";

 /* eslint-disable */
sync(store, router)
trackNavigation(router)

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(require('vue-shortkey'))
Vue.use(VueInteractJs);

(async () => {
  console.log("main.js")
  if (localStorage.getItem('token-type') !== "Internal") {
    await initKeycloak();
  }
  new Vue({
    router,
    store,
    created () {
      const userString = localStorage.getItem('user')
      if (userString && localStorage.getItem('token-type') === "Internal") {
        const userData = JSON.parse(userString)
        this.$store.commit('SET_USER_DATA', userData)
      }
      apiServer.interceptors.response.use(
        response => response,
        error => {
          console.log("Response Intercept Error")
          console.log(error)
          console.log(error.response)
          if (error.response.status === 401) {
            let tokenType = localStorage.getItem('token-type')
            let snackbarText = "Sesi Anda invalid. Silakan login kembali.";
            if (tokenType === "Keycloak") {
              snackbarText = "Sesi SSO Keycloak Anda invalid. Silakan login kembali.";
            } else if (tokenType === "Internal"){
              snackbarText = "Sesi Anda invalid karena sesi berakhir atau Anda telah login di perangkat lain. Silakan login kembali.";
            }
            this.$store.dispatch("setSnackbar", {
              snackbarColor: "red",
              snackbarText: snackbarText,
            });
            if (localStorage.getItem('user') !== null) {
              this.$store.dispatch('logout')
            }
          }
          return Promise.reject(error)
        }
      )
    },
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})();